import ChatContainer from "@/components/ChatContainer/chatContainer.component";
import { Button } from "@/shadcn/components/ui/button";
import { ArrowRightFromLine } from "lucide-react";
import React from "react";

type ChatSingleTaskProps = {
  taskID: number;
  closeChat: () => void;
};

const ChatSingleTask: React.FC<ChatSingleTaskProps> = ({
  taskID,
  closeChat,
}) => {
  return (
    <div className="w-full h-full flex flex-col overflow-hidden p-5">
      <div className="flex justify-between items-center">
        <div className="w-full">
          <h1 className="font-bold text-center text-2xl">Task Chat</h1>
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="btn btn-primary rounded-sm"
          onClick={closeChat}
        >
          <ArrowRightFromLine className="w-5 h-5" />
        </Button>
      </div>
      <ChatContainer chatID={[taskID]} type="singleTaskChat" />
    </div>
  );
};

export default ChatSingleTask;
